import styled from "styled-components";

export const CaptionContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 15px;
    height: auto;
    justify-content: center;
    padding-bottom: 100px;

    @media (min-width: 720px) {
        align-items: center;
        flex-direction: row;
        gap: 5px;
        height: 14%;
        justify-content: flex-start;
        padding-bottom: 0px;
    }

    @media (min-width: 1281px) {
        height: 8%;
    }
`;

export const LegendPopUp = styled.div`
    align-items: center;
    background: #FFFFFF;
    border-radius: 10px;
    box-shadow: 0px 1.52px 1.52px 0px rgba(0, 0, 0, 0.25);
    display: flex;
    flex-direction: column;
    gap: 5px;
    height: auto;
    justify-content: center;
    padding: 10px;
    position: absolute;
    top: ${props => (props?.$top?.top? props?.$top?.top+15 : 70)}px;
    z-index: 9999;
`;

export const CaptionButton = styled.button`
    background: ${({ $showCaption })  => $showCaption ? '#3C9' : '#FFFFFF'};
    border: none;
    border-radius: 3.676px;
    box-shadow: 1.52px 1.52px 1.52px 0px rgba(0, 0, 0, 0.25);
    color: ${({ $showCaption })  => $showCaption ? '#FFFFFF' : '#333'};
    cursor: pointer;
    display: flex;
    font-size: 10px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    outline: none;
    padding: 5px;
    text-align: center;
    transition: 0.5s;

    @media (min-width: 1281px) {
        font-size: 14px;
    }
`;

export const CaptionContent = styled.div`
    align-items: center;
    display: ${({ $showCaption }) => $showCaption ? 'flex' : 'none'};
    flex-wrap: wrap;
    gap: 15px;
    justify-content: center;
    /* margin-left: 10px;
    transition: 1s; */
    
    @media (min-width: 720px) {
        justify-content: flex-start;
    }

    @media (orientation: landscape) and (max-width: 1200px) {
        background: #FFFFFF;
        border-radius: 10px;
        box-shadow: 0px 1.52px 1.52px 0px rgba(0, 0, 0, 0.25);
        flex-direction: column;
        gap: 5px;
        height: auto;
        padding: 10px;
        position: absolute;
        right: -2px;
        top: ${({ $top }) => $top?.top ? $top?.top + 15 : 70}px;
        z-index: 9999;
    }
`;

export const CaptionItem = styled.div`
    align-items: center;
    background: #FFFFFF;
    border-radius: 3.676px;
    box-shadow: 1.52px 1.52px 1.52px 0px rgba(0, 0, 0, 0.25);
    color: #333;
    display: flex;
    flex-direction: row;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    gap: 8px;
    justify-content: center;
    line-height: normal;
    padding: 5px;
    @media (min-width: 1281px) {
        font-size: 15px;
    }
`;

export const CaptionCircle = styled.div`
    background: ${({ $background }) => $background};
    border-radius: 50%;
    color: #F6F6F6;
    display: flex;
    height: 18px;
    justify-content: center;
    width: 18px;
    @media (min-width: 1281px) {
        height: 20px;
        width: 20px;
    }
`;

export const CaptionImg = styled.img`
    align-items: center;
    display: flex;
    height: 18px;
    justify-content: center;
    width: 18px;
    @media (min-width: 1281px) {
        height: 20px;
        width: 20px;
    }
`;